<template>
  <div style="width: auto;display: flex;justify-content: flex-start;">
    <div v-for="item in imageList" class="imgBox">
      <img :src="item.src" alt="">
      <!--<span :title="item.name">{{item.name}}</span>-->
      <div class="imgMask">
        <i class="el-icon-delete" @click="deleteImg(item.src)"></i>
      </div>
    </div>
    <input id="uploadImg" name="file" accept="image/*" type="file" multiple="multiple" style="display: none;" />
    <a class="chooseImg" @click="upImg">
      <span><i class="el-icon-plus"></i></span>
      <span>点击上传</span>
    </a>
  </div>
</template>

<script>
  import $ from 'jquery'
  import {nError} from '../../utils/notice'

  export default {
    name: 'upload-img-list',
    props: {
      defaultImg: Array,
      ImgNumber: {
        type: Number,
        default () {
          return 100
        }
      }
    },
    data () {
      return {
        base64List: [], // 转化base64后的图片数组
        imageList: []
      }
    },
    methods: {
      upImg () {
        let _self = this
        let imgNumber = this.ImgNumber
        $('#uploadImg')
          .click() // 隐藏了input:file样式后，点击头像就可以本地上传
          .on('change', function () {
            let imgList = this.files
            for (let m = 0; m < imgList.length; m++) {
              // if (imgList[m].size < 32768 || imgList[m].size > 131072) {
              //   nError('上传图片不能小于32KB且不能大于128KB！')
              //   let obj = document.getElementById('uploadImg')
              //   obj.outerHTML = obj.outerHTML
              //   return false
              // }
              let objFile = {
                name: '',
                src: ''
              }
              objFile.name = imgList[m].name
              objFile.src = _self.getObjectURL(imgList[m]) // 获取图片的路径，该路径不是图片在本地的路径
              if (objFile) {
                let isExist = false
                for (let n = 0; n < _self.imageList.length; n++) {
                  if (_self.imageList[n].name && _self.imageList[n].name.split('.')[0] === objFile.name.split('.')[0]) {
                    isExist = true
                  }
                }
                if (_self.imageList.length >= imgNumber) {
                  nError(`单次上传图片不能超过${imgNumber}张！`)
                  _self.upData(imgList)
                  return false
                }
                if (!isExist) {
                  _self.imageList.push(objFile)
                }
              }
            }
            _self.upData(imgList)
            let obj = document.getElementById('uploadImg')
            obj.outerHTML = obj.outerHTML
          })
      },
      getObjectURL (file) {
        let url = null
        if (window.createObjectURL !== undefined) { // basic
          url = window.createObjectURL(file)
        } else if (window.URL !== undefined) { // mozilla(firefox)
          url = window.URL.createObjectURL(file)
        } else if (window.webkitURL !== undefined) { // webkit or chrome
          url = window.webkitURL.createObjectURL(file)
        }
        return url
      },
      upData (fileList) {
        const _self = this
        console.log(fileList)
        for (let i = 0; i < fileList.length; i++) {
          let oFReader = new FileReader()
          oFReader.readAsDataURL(fileList[i])
          oFReader.onloadend = function (oFRevent) {
            let obj = {
              code: '',
              personImageStr: ''
            }
            obj.code = fileList[i].name.split('.')[0]
            obj.personImageStr = oFRevent.target.result
            _self.base64List.push(obj)
          }
        }
      },
      // 单个删除
      deleteImg (src) {
        for (let i = 0; i < this.imageList.length; i++) {
          if (this.imageList[i].src === src) {
            this.imageList.splice(i, 1)
          }
        }
      }
    },
    watch: {
      imageList (val) {
        this.$emit('getImgList', this.imageList, this.base64List)
      },
      defaultImg (val) {
        let arr = []
        for (let i = 0; i<val.length; i++) {
          let obj = {
            src: ''
          }
          obj.src = val[i]
          arr.push(obj)
        }
        this.imageList = arr
      }
    }
  }
</script>

<style scoped>
  .uploadImg {
    min-width: 90px;
    align-items: center;
    padding: 0;
    cursor: pointer;
    font-size: 14px;
    border-radius: 5px;
    outline: none;
    color: #48576A;
    line-height: 28px;
    background-color: #F7F7F7;
    border: 1px solid #D7D7D7;
  }
  .uploadImg:hover {
    cursor: pointer;
    color: #1362FF;
    background-color: #F7F7F7;
    border: 1px solid #1362FF;
  }
  .imgMask {
    width: 120px;
    height: 90px;
    display: none;
    background-color: rgba(102, 102, 102, .7);
    position: absolute;
    top: 10px;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
  .imgMask i {
    width: 20px;
    color: #FFFFFF;
    line-height: 90px;
    font-size: 20px;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
  .chooseImg {
    display: inline-block;
    width: 120px;
    height: 90px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin: 0 10px;
    position: relative;
    top: 12px;
  }

  .chooseImg span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }

  .chooseImg span:first-child {
    font-size: 24px;
    line-height: 20px;
    position: absolute;
    top: 25px;
  }

  .chooseImg span:last-child {
    font-size: 14px;
    line-height: 20px;
    position: absolute;
    bottom: 0;
  }

  .imgBox {
    width: 120px;
    height: 90px;
    margin: 0 5px;
    border: 1px solid #ffffff;
    position: relative;
  }

  .el-icon-error {
    display: none;
    color: #f25721;
    position: absolute;
    top: 2px;
    right: 2px;
  }

  .imgBox img {
    width: 120px;
    height: 90px;
    display: block;
    margin: 10px auto 0;
  }
  .imgBox span {
    width: 120px;
    display: block;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>

<style lang="less">
.uploadImgBox .el-dialog .el-dialog__body {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  height: 320px;
  padding: 20px;
  overflow-y: scroll;
}
.imgBox:hover {
  .imgMask {
    display: block;
  }
}
.imgMask i:hover {
  cursor: pointer;
  color: #f25721;
}
</style>



// WEBPACK FOOTER //
// src/components/Input/UploadImgList.vue